import { supabase } from './supabase';

export interface RequestSendNowResult {
  queued: boolean;
  scheduled_email_id: string;
}

/** Queue immediate send for one pending scheduled_emails row (admin only). */
export async function requestSendScheduledEmailNow(
  scheduledEmailId: string,
): Promise<RequestSendNowResult> {
  const { data, error } = await supabase.functions.invoke('request-send-scheduled-email', {
    body: { scheduled_email_id: scheduledEmailId },
  });

  if (error) {
    throw new Error(error.message || 'Send now request failed');
  }

  const payload = data as { error?: string; queued?: boolean; scheduled_email_id?: string } | null;
  if (payload?.error) {
    throw new Error(payload.error);
  }
  if (!payload?.queued || !payload.scheduled_email_id) {
    throw new Error('Unexpected response from send-now service');
  }

  return {
    queued: true,
    scheduled_email_id: payload.scheduled_email_id,
  };
}
